import script from "./PollutantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PollutantModal.vue?vue&type=script&setup=true&lang=js"

import "./PollutantModal.vue?vue&type=style&index=0&id=3831f6ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3831f6ea"]])

export default __exports__